export default {"src":"/_next/static/media/Giveaway.bf4b9fe1.svg","height":92,"width":91};